import React from 'react'
import { Button, Modal, ModalBody } from 'reactstrap';
import "./ModalAutorizacion.css";
import { validarPasswordEliminar } from '../../../Services/Validaciones';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import SpinnerModal from '../SpinnerModal/SpinnerModal';
import { estiloColorError, estilosModal, estiloFiltroEncabezados } from '../../../Services/PaletaDeColores';
import {
  deleteClienteContacto, deleteClienteDireccion, deleteClienteDocumento,
  deleteProveedorContacto, deleteProveedorDireccion, deleteProveedorDocumento
} from '../../../Services/Api';


export default class ModalAutorizacion extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      show: props.show,
      titulo: props.titulomodal,

      colormsgerror: estiloColorError().msgerror,
      estilosmodal: estilosModal(),
      colortitulo: estiloFiltroEncabezados().colortitulos,

      txtpassword: "",
      vermsgerrortxtpassword: false,
      msgerrortxtpassword: "",

      txtprincipal: "",
      vermsgerrortxtprincipal: false,
      msgerrortxtprincipal: ""

    }

  }
  async componentDidMount() {
    setTimeout(async () => {
      this.refInput.focus();
    }, 500);
  }

  setLoadingSpinner = (bandera) => {
    this.props.setloadingspinner(bandera);
  }

  showModal = (accion) => {
    this.setState({ show: false });
    setTimeout(() => {
      this.props.cerrarModalAtutorizacion(accion);
    }, 200);
  }

  escribir = (prop) => (event) => {
    this.setState({ [prop]: event.target.value });
  };

  eliminarItem = async () => {

    let validacionescorrectas = true
    this.setState({ vermsgerrortxtpassword: false })
    this.setState({ vermsgerrortxtprincipal: false })

    let txtpassword = validarPasswordEliminar(this.state.txtpassword.trim())
    if (txtpassword.codigo == "invalid") {
      this.setState({ msgerrortxtpassword: txtpassword.mensaje })
      this.setState({ vermsgerrortxtpassword: true })
      validacionescorrectas = false;
    }

    try {

      if (this.props.item.principal) {
        this.setState({ msgerrortxtprincipal: 'Un registro pincipal no puede ser eliminado' })
        this.setState({ vermsgerrortxtprincipal: true })
        validacionescorrectas = false;
      }
    } catch (error) {

    }
    if (validacionescorrectas) {
      this.setLoadingSpinner(true);
      var resp = {};
      var json = {};

      if (this.props.accion == 0) {
        json = {
          idcatalogo_clientes_contactos: this.props.item.idcatalogo_clientes_contactos,
          password: this.state.txtpassword
        }
        resp = await deleteClienteContacto(json)
      }
      else if (this.props.accion == 1) {
        json = {
          idcatalogo_clientes_direcciones: this.props.item.idcatalogo_clientes_direcciones,
          password: this.state.txtpassword
        }
        resp = await deleteClienteDireccion(json)
      }
      else if (this.props.accion == 2) {
        json = {
          idcatalogo_clientes_documentos: this.props.item.idcatalogo_clientes_documentos,
          password: this.state.txtpassword
        }
        resp = await deleteClienteDocumento(json)
      }
      else if (this.props.accion == 10) {
        json = {
          idcatalogo_proveedores_contactos: this.props.item.idcatalogo_proveedores_contactos,
          password: this.state.txtpassword
        }
        resp = await deleteProveedorContacto(json)
      }
      else if (this.props.accion == 11) {
        json = {
          idcatalogo_proveedores_direcciones: this.props.item.idcatalogo_proveedores_direcciones,
          password: this.state.txtpassword
        }
        resp = await deleteProveedorDireccion(json)
      }
      else if (this.props.accion == 12) {
        json = {
          idcatalogo_proveedores_documentos: this.props.item.idcatalogo_proveedores_documentos,
          password: this.state.txtpassword
        }
        resp = await deleteProveedorDocumento(json)
      }

      else if (this.props.accion == 30) {
     
        this.showModal("30")
      }


      if (resp == -1 || resp.code == 1000) {
        toast.error("Error de conexión", { autoClose: 1000, position: toast.POSITION.TOP_LEFT });
        this.setLoadingSpinner(false)
        return;
      }
      else if (resp.code == 200 || resp.code == 300 || resp.ccode == 400) {
        this.setLoadingSpinner(false)
        toast.error(resp.message, { autoClose: 1000, position: toast.POSITION.TOP_LEFT })
        return;
      }
      else {
        toast.success("Elemento eliminado correctamente", { autoClose: 1000, position: toast.POSITION.TOP_LEFT })
        this.showModal('1')
      }
    }
  }


  render() {
    return (

      <>
        {(this.state.loadingspinners == true) ? (
          <SpinnerModal tipo="full" show={this.state.loadingspinners} />
        ) : null}

        <ToastContainer />

        <Modal isOpen={this.state.show}
          size="md"
          aria-labelledby=""
          centered>
          <ModalBody>
            <div className="divTituloModal">
              <label className="modalLblTitulo letraTitulos" style={{ color: this.state.colortitulo }} >{this.state.titulo}</label>
            </div>

            <br />

            <div className="divModalEliminar">
              <div className="divContenedorModal" style={{ backgroundColor: this.state.estilosmodal.fondocontenedormodal, boxSizing: "content-box" }}>

                <p className='lblSubTitulosModal letraTitulos' style={{ color: this.state.estilosmodal.colorlblsubtitulosmodal }}>Ingresa tu contraseña</p>

                <input className='lblTextoModal letraNormal' style={{ color: this.state.estilosmodal.colorlbltextomodal, backgroundColor: this.state.estilosmodal.fondocontenedormodal, border: 'none', borderBottom: this.state.estilosmodal.colorborderbottom }}
                  type={'password'} value={this.state.txtpassword} onChange={this.escribir("txtpassword")} ref={(input) => { this.refInput = input; }}></input>

                {this.state.vermsgerrortxtpassword ? <p className="msgError letraNormal"
                  style={{ color: this.state.colormsgerror }}>{this.state.msgerrortxtpassword}</p> : null}

                {(!this.state.vermsgerrortxtpassword && this.state.vermsgerrortxtprincipal) ? <p className="msgError letraNormal"
                  style={{ color: this.state.colormsgerror }}>{this.state.msgerrortxtprincipal}</p> : null}


              </div>
            </div>

            <div className="divBtnContenedorModal" >
              <Button className="btnCancelModal" onClick={() => this.showModal('0')}>Cancelar</Button>
              <Button className="btnAceptarModal" onClick={() => this.eliminarItem()} >Continuar</Button>
            </div>

          </ModalBody>

        </Modal>
      </>
    )
  }
}
